import React from 'react'
import { ServiceCardData } from './Components/ServiceCardData'
import { BankServicesData } from './Components/BankServicesData'
import { Link } from 'react-router-dom'

const Services = () => {
  return (
    <div>
      {/* x---------------------------------x Service Cards Section x---------------------------------x */}
      <div className="row row g-sm-3 g-1 justify-content-center">
        {ServiceCardData.map((data, index) => {
          return (
            // x---------------------------------x Service Cards x---------------------------------x 
            <div className="col-lg-4 col-sm-6" key={index} >
              <div className="card border-0 bg-transparent h-100">
                <div className="card-body rounded-4 mb-3 mb-sm-0 bg-white">
                  <div className="d-flex">
                    <div
                      className={`card-img avatar lg no-thumbnail rounded-circle me-3 ${data.icon_bg}`}>
                      {data.icon}
                    </div>
                    <div className="card-text">
                      <p className="text-secondary fs-5 fw-bold  m-0">{data.Heading}</p>
                      <span className="text-muted fs-6 fw-semibold  m-0">{data.Description}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* x---------------------------------x Bank Services Lists x---------------------------------x */}
      <div className="row g-sm-3 g-1 mt-1 mt-sm-3">
        <div className="col-sm-12">
          <div className="card border-0 bg-transparent h-100">
            <div className="card-header justify-content-between">
              <h3 className="text-dark fs-5 fw-semibold ">Bank Services List</h3>
              <Link to="/" className="text-dark text-end fs-6 fw-semibold  d-block d-sm-none">see
                all</Link>
            </div>
            <div className="card-body pt-3 px-3 rounded-4">
              <ul className="row g-2 li_animate list-unstyled mb-0" id="MyClients">
                {BankServicesData.map((data, index) => (
                  // x---------------------------------x Bank Services List x---------------------------------x
                  <li className="col-sm-6 col-md-12" key={index} >
                    <div className="bg-card p-3 rounded-4">
                      <div className="row g-3 align-items-center">
                        <div className="col-lg-3 col-md-12">
                          <div className="d-flex gap-3 align-items-center">
                            <div className={`avatar lg no-thumbnail rounded-4 ${data.icon_bg}`}>
                              {data.icon}
                            </div>
                            <div>
                              <h6 className="mb-1">{data.ServiceType}</h6>
                              <span className="text-muted">{data.ServiceTypeText}</span>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-9 col-md-12">
                          <ul className="list-unstyled d-flex gap-xl-4 gap-3 mb-0 flex-column flex-md-row justify-content-lg-between">
                            <li>
                              <div>
                                <h6 className="mb-1">{data.ServiceSuggestion}</h6>
                                <span className="text-muted">{data.ServiceSuggestionText}</span>
                              </div>
                            </li>
                            <li>
                              <div>
                                <h6 className="mb-1">{data.Type}</h6>
                                <span className="text-muted">{data.Type}</span>
                              </div>
                            </li>
                            <li>
                              <div>
                                <h6 className="mb-1">{data.Control}</h6>
                                <span className="text-muted">{data.ControlText}</span>
                              </div>
                            </li>
                            <li>
                              <Link to="/business-loan" className="btn btn-outline-primary rounded-5 px-4 text-decoration-none">
                                View More
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div >
  )
}

export default Services